import React, {useState,useEffect} from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams,useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import AddSvg from '../../svg/admin/Add';
import MoreSvg from '../../svg/admin/More';
import { fetchMissions, insertNewMission } from '../../services2/pmissions.service';
import PageSelector from '../components/PageSelector';
function Component(props) {
  const {  } = useParams();
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const [data,setdata] = useState(null)
  const [isLoading,setisLoading]=useState(false)
  const [total,settotal]=useState(0)


  const filter= searchParams.get('filter')|| '全部';
  const status = searchParams.get('status')|| '全部';
  const page= parseInt(searchParams.get('page'))||1;
  const limit= 10
  const totalPage = Math.ceil(total/limit)||1

  const handleSelectPage=(p)=>async ()=>{
    if(p > totalPage || p < 1) return;
    searchParams.delete('page')
    searchParams.set('page', p)
    setSearchParams(searchParams)
}

  const fetchData=async(force=false)=>{
    if(isLoading&&!force)return
    setisLoading(true)
    const filter={}
    if(status!=='全部')filter.status=status
    let result = await fetchMissions(props.token.token,filter,{limit,skip:(page-1)*limit});
    if(result.result){
        setdata(result.result)
        settotal(result.count||0)
    }else{
        alert('Fetch data error')
    }
    setisLoading(false)
  }


  const onSelectFilter=(item,index)=>{
    searchParams.delete('filter')
    searchParams.delete('page')
    searchParams.set('filter', item)
    searchParams.set('page', 1)
    setSearchParams(searchParams)
  }

  const selectStatusFilter=(s)=>()=>{
    searchParams.delete('status')
    searchParams.delete('page')
    searchParams.set('status', s)
    searchParams.set('page', 1)
    setSearchParams(searchParams)
  }


  useEffect(() => {
    const timer = setTimeout(fetchData, 500)
    const interval = setInterval(fetchData,1000*30)
    return () => {
        clearTimeout(timer)
        clearInterval(interval)
    }
  },[searchParams])

  const [isCreating,setisCreating]=useState(null)
  const handleNewMissionInput=(e)=>{setisCreating({name:e.target.value})}
  const handleCreateNewMission=async()=>{
    if(!isCreating?.name){
        alert('閲讀任務名稱 is empty')
        return
    }
    setisLoading(true)
    let result = await insertNewMission(props.token?.token,isCreating?.name)
    if(result?.errno){
        alert(result?.message||'error')
    }else{
        console.log(result)
        let insertedId= result?.result?.insertedId
        setisCreating(null)
        if(insertedId){
            navigate(`/platform2/missions/${insertedId}`)
        }
    }
    setisLoading(false)
  }


  return (
    <div className='h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px]'>
        {/*title, filter, serach box*/}
        <div className='p-[16px] flex flex-row items-center justify-between items-center bg-[white] rounded-[10px] gap-[8px] flex-wrap'>
            <div className='text-[#212121] text-[20px] font-[700]'>閲讀任務管理</div>
            <div className='flex flex-row items-center gap-[8px] flex-wrap'>
                {/* <DropDownMenu select={onSelectFilter} value={filter} options={['全部','1','2','3']}/>
                <div className='text-[14px] py-[8px] px-[16px] rounded-[7px] gap-[4px] flex flex-row' style={{border:'.5px solid #00000080'}}>
                    <SearchSvg/>
                    <input placeholder='搜尋'/>
                </div> */}
                <div onClick={()=>{navigate(`/platform2/questionnaires`)}} className='text-white bg-[#1F4CC8] p-[8px] gap-[8px] flex flex-row rounded-[7px] cursor-pointer items-center text-[14px] hover:opacity-[.8]'>
                    問卷管理
                </div>
                <div onClick={()=>{setisCreating({})}} className='text-white bg-[#1F4CC8] p-[8px] gap-[8px] flex flex-row rounded-[7px] cursor-pointer items-center text-[14px] hover:opacity-[.8]'>
                    <AddSvg/>
                    添加閲讀任務
                </div>
            </div>
        </div>
        {/*end of title, filter, serach box*/}

        {/*status filter*/}
        <div className='flex flex-row gap-[32px] px-[24px] text-[16px] font-[700]'>
            <div className='cursor-pointer px-[8px]' onClick={selectStatusFilter('全部')} style={{color:status==='全部'?'#1F4CC8':'#898989'}}>全部</div>
            <div className='cursor-pointer px-[8px]' onClick={selectStatusFilter('啟動中')} style={{color:status==='啟動中'?'#1F4CC8':'#898989'}}>啟動中</div>
            <div className='cursor-pointer px-[8px]' onClick={selectStatusFilter('未公開')} style={{color:status==='未公開'?'#1F4CC8':'#898989'}}>未公開</div>
        </div>  
        {/*end of status filter*/}  


        {/*list of data*/}
        <div className='flex flex-col flex-1 w-full bg-[white] rounded-[10px] p-[16px] text-[14px]' style={{overflowY:'auto'}}>
            <div className='w-full flex flex-row justify-between font-bold py-[16px]' style={{borderBottom:'1px solid #D1D1D1'}}>
                <div className='flex-1'>閲讀任務名稱</div>
                <div className='flex-1'>分類</div>
                <div className='flex-1'>任務</div>
                <div className='flex-1'>時間</div>
                <div className='flex-1'>狀態</div>
                <div className='w-[32px]'></div>
            </div>
            {data?.map((item,index)=>
                <div key={item?._id||index} className='w-full flex flex-row justify-between font-[400] py-[16px] items-center' style={{borderBottom:'1px solid #D1D1D1'}}>
                    <div className='flex-1'>{item?.name}</div>
                    <div className='flex-1'>{item?.category}</div>
                    <div className='flex-1'>{item?.mission}</div>
                    <div className='flex-1'>{item?.time||'-'} 分鐘</div>
                    <div className='flex-1 flex flex-row'>
                        {item.status==='啟動中'?<div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#DBFFF0] text-[#4DE0A4]'>啟動中</div>
                        :item.status==='未公開'?<div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#FFC8C899] text-[#F06969]'>未公開</div>
                        :<div>{item.status}</div>
                        }
                    </div>
                    <div onClick={()=>{navigate(`/platform2/missions/${item?._id}`)}} className='w-[32px] bg-[#FFD8D0] h-[32px] rounded-[5px] flex justify-center items-center cursor-pointer hover:opacity-[.5]'>
                        <MoreSvg/>
                    </div>
                </div>
            )}
        </div>
        {/*end of list of data*/}
        <PageSelector
            handleSelectPage={handleSelectPage}
            page={page}
            total={total}
            totalPage={totalPage}
        />

        {/*create new mission popup*/}
        {isCreating&&<div className='fixed inset-0 bg-[#00000080] flex justify-center items-center'>
            <div className='flex flex-col items-center bg-white rounded-[10px] p-[16px] gap-[24px]'>
                <div className='text-[#1F4CC8] text-[24px] font-[700]'>添加閲讀任務</div>
                <div className='flex flex-row items-center text-[16px] text-black gap-[24px]'>
                    <div>閲讀任務名稱:</div>
                    <input value={isCreating?.name||''} onChange={handleNewMissionInput} className='rounded-[7px] px-[8px] py-[4px]' style={{border:'.5px solid #999'}} placeholder='任務名稱'/>
                </div>
                <div className='flex flex-row items-center text-[16px] text-black gap-[8px] font-[700]'>
                    <div onClick={()=>{setisCreating(null)}} className='text-white bg-[#aaa] px-[16px] py-[8px] gap-[8px] flex flex-row rounded-[7px] cursor-pointer items-center text-[14px] hover:opacity-[.8]'>
                        取消
                    </div>
                    <div onClick={handleCreateNewMission} className='text-white bg-[#1F4CC8] px-[16px] py-[8px] gap-[8px] flex flex-row rounded-[7px] cursor-pointer items-center text-[14px] hover:opacity-[.8]'>
                        確認
                    </div>
                </div>
            </div>
        </div>}  
        {/*end of create new mission popup*/}
        {isLoading&&<LoadingPage/>}
    </div>
  );
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)
  